export const resolveAnimationHeight = (
  contentHeight: number | null,
  isClosing: boolean,
  isOpen: boolean,
): string => {
  if (isClosing || !isOpen) {
    return '0px';
  }

  if (contentHeight === null) {
    // Skip-open path before first measurement: render at natural height
    // (auto → px is non-transitionable, so no flash animation)
    return 'auto';
  }

  return `${contentHeight}px`;
};
